<div class="auth-container">
    <div class="auth-header"></div>
    <div class="auth-body">
        <img
            class="app-logo"
            src="/assets/icons/moveright-simplified.svg"
            alt="Move Right Moving Simplified"
            width="256px"
            height="256px"
        />

        <ng-container *ngIf="faErrorMessage; else redirecting">
            <p class="fa-error" role="alert">{{ faErrorMessage }}</p>
            <button class="retry-btn" type="button" (click)="redirectToFA()">Sign in again</button>
        </ng-container>
        <ng-template #redirecting>
            <p class="redirect-note">Redirecting to sign in…</p>
        </ng-template>
    </div>
    <app-auth-footer supportMessage="I'm having trouble signing in"></app-auth-footer>
</div>